export const APP_NAME = 'recommendations_list_perseus';
